import { render, staticRenderFns } from "./GoalEdit.vue?vue&type=template&id=e70f71c4&scoped=true"
import script from "./GoalEdit.vue?vue&type=script&lang=js"
export * from "./GoalEdit.vue?vue&type=script&lang=js"
import style0 from "./GoalEdit.vue?vue&type=style&index=0&id=e70f71c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f71c4",
  null
  
)

export default component.exports